module.exports = __webpack_public_path__ + "static/contribution_img3@2x-ce2d9468b6ce58f8bcae1f83ea100443.jpg";